import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Kanban des actions d'un plan. Drag-and-drop entre colonnes -> POST au move de
// l'action avec le champ correspondant au regroupement courant (statut /
// priorite / owner_id / axe=plan_action_section_id).
export default class extends Controller {
  static targets = ["body"]
  static values  = { groupBy: String, moveUrlTemplate: String }

  connect() {
    this.sortables = this.bodyTargets
      .filter(b => b.dataset.dragEnabled === "true")
      .map(body => Sortable.create(body, {
        group: "pa-cards",
        animation: 150,
        ghostClass: "sortable-ghost",
        dragClass: "sortable-drag",
        onAdd: this._onAdd.bind(this)
      }))
  }

  disconnect() {
    this.sortables?.forEach(s => s.destroy())
  }

  async _onAdd(event) {
    const card    = event.item
    const newCol  = event.to.closest(".kanban__column")
    const oldCol  = event.from.closest(".kanban__column")
    const id      = card.dataset.cardId
    const colKey  = newCol?.dataset.kanbanColumnKey
    if (!id) return

    const field = this.groupByValue === "axe" ? "plan_action_section_id" : this.groupByValue
    const url   = this.moveUrlTemplateValue.replace("__id__", id)
    const csrf  = document.querySelector('meta[name="csrf-token"]')?.content

    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": csrf || "" },
      body: JSON.stringify({ field, value: colKey === "" ? null : colKey })
    })

    if (!res.ok) {
      alert("Le déplacement n'a pas pu être enregistré.")
      window.location.reload()
      return
    }
    this._count(newCol, +1)
    this._count(oldCol, -1)
  }

  _count(col, delta) {
    const c = col?.querySelector(".kanban__column-count")
    if (c) c.textContent = String(parseInt(c.textContent || "0", 10) + delta)
  }
}
